import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { LoadingBlock } from "@/components/AsyncState";
import { VendorAmbianceTagsPage } from "@/components/vendor/ambiance-tags/VendorAmbianceTagsPage";
import { getStoredVendorVenueId } from "@/lib/vendorPortal";

export const Route = createFileRoute("/vendor/ambiance-tags")({
  head: () => ({ meta: [{ title: "Ambiance-Tags · Venue Portal" }] }),
  component: VendorAmbianceTagsRoute,
});

function VendorAmbianceTagsRoute() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getStoredVendorVenueId()) {
      void navigate({ to: "/vendor/login", replace: true });
      return;
    }
    setReady(true);
  }, [navigate]);

  if (!ready) return <LoadingBlock label="Ambiance-Tags laden…" />;
  return <VendorAmbianceTagsPage />;
}
